import { render } from "./AddTypeEmplacementModal.vue?vue&type=template&id=3fdd1f4b&ts=true"
import script from "./AddTypeEmplacementModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeEmplacementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__